import { useState } from "react";
import { Chip, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import AnimatedTable, { ColumnDef } from "../AnimatedTable";

const mockAllocations = [
  {
    id: 1,
    event: "Corporate Gala Live Stream",
    type: "Conference",
    date: "2026-05-15",
    crew: "--",
    status: "Confirmed",
  },
  {
    id: 2,
    event: "John Doe",
    type: "Memorial",
    date: "2026-06-20",
    crew: "--",
    status: "Pending",
  },
  {
    id: 3,
    event: "Michael Jackson",
    type: "Funeral",
    date: "2026-09-10",
    crew: "--",
    status: "Confirmed",
  },
];

export default function AllocationsTab() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [allocPage, setAllocPage] = useState(0);

  const chipSx = {
    bgcolor: colors.neutral[700],
    color: theme.palette.text.primary,
    fontWeight: 600,
    borderRadius: "16px",
  };

  const allocationColumns: ColumnDef<(typeof mockAllocations)[0]>[] = [
    {
      key: "event",
      label: "Event",
      cellSx: { fontWeight: 500, color: theme.palette.text.primary },
      render: (row) => row.event,
    },
    { key: "type", label: "Type", render: (row) => row.type },
    { key: "date", label: "Date", render: (row) => row.date },
    { key: "crew", label: "Crew", render: (row) => row.crew },
    {
      key: "status",
      label: "Status",
      render: (row) => <Chip label={row.status} size="small" sx={chipSx} />,
    },
  ];

  return (
    <AnimatedTable
      columns={allocationColumns}
      rows={mockAllocations}
      getRowId={(row) => row.id}
      page={allocPage}
      totalPages={1}
      onPageChange={setAllocPage}
      emptyMessage="No allocations found."
    />
  );
}
